import { css } from 'styled-system/css';

export const quickBetStyle = {
	quickBetWrapper: css({
		base: {
			padding: '12px 12px 0 12px'
		}
	}),
	betButton: css({
		base: {
			'--bet-button-color': { base: 'colors.primary.500', _dark: 'colors.primary.300' },
			w: '100%',
			mt: '12px',
		},
		_mars: {

			'&:not([data-disabled="true"])': {
				bgColor: 'var(--bet-button-color)',
				color: 'whiteOpacity.100',
			},
			'&:not([data-disabled="true"]) .bet-slip__betting-amount': {
				color: 'whiteOpacity.100',
			},
		},
	}),
}